module.exports = __webpack_public_path__ + "img/avatar-eli-ganim.64b75c33.jpg";